import MainLayout from '../layouts/main';
import StudentExamsContainer from './container';

function StudentExamsPage() {
  return (
    <MainLayout title={STUDENT_EXAM_PAGE_TITLE}>
      <StudentExamsContainer />
    </MainLayout>
  );
}

export const STUDENT_EXAM_PAGE_TITLE = 'نتایج آزمون‌ها';

export default StudentExamsPage;
